export default __webpack_public_path__ + "static/media/villa_9.2ffcfed4.jpg";